import { requestCSVActionTypes, downloadCSVActionTypes } from './actions';

const initialState = {
  loading: false,
  format: '',
  error: false,
  requestId: '',
};

const handleRequestCSVRequest = (state, action) => ({
  ...state,
  loading: true,
  format: action.format,
  error: false,
});

const handleRequestCSVSuccess = (state, action) => ({
  ...state,
  requestId: action.requestId,
});

const handleDownloadCSVSuccess = (state) => ({
  ...state,
  loading: false,
  format: '',
});

const handleDownloadCSVError = (state, action) => ({
  ...state,
  loading: false,
  format: '',
  error: action.error,
});

export default (state = initialState, action) => {
  const handlers = {
    [requestCSVActionTypes.request]: handleRequestCSVRequest,
    [requestCSVActionTypes.success]: handleRequestCSVSuccess,
    [downloadCSVActionTypes.success]: handleDownloadCSVSuccess,
    [downloadCSVActionTypes.error]: handleDownloadCSVError,
  };

  return handlers[action.type]
    ? handlers[action.type](state, action)
    : state;
};
